export default __webpack_public_path__ + "static/media/onedrive-logo.75585482.svg";